// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Privacy Policy Page Styles */
.privacy-policy-page {
  min-height: 100vh;
  background: #f8fafc;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

.privacy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 2rem;
}

.back-arrow {
  font-size: 18px;
  font-weight: bold;
}

.back-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.privacy-content {
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.privacy-content h1 {
  color: #1f2937;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.last-updated {
  color: #6b7280;
  font-size: 1rem;
  margin-bottom: 2rem;
  font-style: italic;
}

.privacy-text {
  line-height: 1.7;
  color: #374151;
}

.privacy-text h2 {
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 2rem 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.privacy-text h3 {
  color: #374151;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 1.5rem 0 0.75rem 0;
}

.privacy-text p {
  margin-bottom: 1rem;
  color: #4b5563;
}

.privacy-text ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.privacy-text li {
  margin-bottom: 0.5rem;
  color: #4b5563;
}

.privacy-text a {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.privacy-text a:hover {
  color: #2563eb;
  text-decoration: underline;
}

.contact-info {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.contact-info p {
  margin-bottom: 0.5rem;
  color: #374151;
}

.contact-info strong {
  color: #1f2937;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .privacy-container {
    padding: 1rem;
  }
  
  .privacy-content {
    padding: 2rem;
  }
  
  .privacy-content h1 {
    font-size: 2rem;
  }
  
  .privacy-text h2 {
    font-size: 1.25rem;
  }
  
  .privacy-text h3 {
    font-size: 1.125rem;
  }
}

@media (max-width: 480px) {
  .privacy-content {
    padding: 1.5rem;
  }
  
  .privacy-content h1 {
    font-size: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivacyPolicy.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iHAAiH;AACnH;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Privacy Policy Page Styles */\n.privacy-policy-page {\n  min-height: 100vh;\n  background: #f8fafc;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n}\n\n.privacy-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 2rem;\n}\n\n.back-arrow {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.back-button:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.privacy-content {\n  background: white;\n  border-radius: 12px;\n  padding: 3rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.privacy-content h1 {\n  color: #1f2937;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.last-updated {\n  color: #6b7280;\n  font-size: 1rem;\n  margin-bottom: 2rem;\n  font-style: italic;\n}\n\n.privacy-text {\n  line-height: 1.7;\n  color: #374151;\n}\n\n.privacy-text h2 {\n  color: #1f2937;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 2rem 0 1rem 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.privacy-text h3 {\n  color: #374151;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 1.5rem 0 0.75rem 0;\n}\n\n.privacy-text p {\n  margin-bottom: 1rem;\n  color: #4b5563;\n}\n\n.privacy-text ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.privacy-text li {\n  margin-bottom: 0.5rem;\n  color: #4b5563;\n}\n\n.privacy-text a {\n  color: #3b82f6;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.privacy-text a:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n.contact-info {\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n}\n\n.contact-info p {\n  margin-bottom: 0.5rem;\n  color: #374151;\n}\n\n.contact-info strong {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .privacy-container {\n    padding: 1rem;\n  }\n  \n  .privacy-content {\n    padding: 2rem;\n  }\n  \n  .privacy-content h1 {\n    font-size: 2rem;\n  }\n  \n  .privacy-text h2 {\n    font-size: 1.25rem;\n  }\n  \n  .privacy-text h3 {\n    font-size: 1.125rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .privacy-content {\n    padding: 1.5rem;\n  }\n  \n  .privacy-content h1 {\n    font-size: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
